export const SEARCH_TYPE = "searchType";
export const SEARCH_CRITERIA = "searchCriteria";

export const searchType = [
  { label: "Document ID", value: "postDocumentHeaderId" },
  { label: "Amount", value: "amount" },
];
